/* eslint-disable @typescript-eslint/no-explicit-any */
import { useReducer } from 'react';
import { isPrimitive } from '@clover-util/is-primitive';
import { isFunction } from '@clover-util/is-function';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
function mergeStateReducer(state, action) {
    const newValue = isFunction(action) ? action(state) : action;
    // was state a primitive or function ? use Object.is
    if (isPrimitive(state) || isFunction(state))
        return newValue;
    // Are both state and newValue arrays?
    if (Array.isArray(state) && Array.isArray(newValue)) {
        // not same length? return new value (optimization) p
        if (state.length !== newValue.length)
            return newValue;
        // shallow compare
        const updatedValues = newValue.filter((value, index) => !Object.is(state[index], value));
        // any values updated ?
        return updatedValues.length ? newValue : state;
    }
    // make sure update is an object we can get keys off of
    if (Array.isArray(newValue) || isPrimitive(newValue) || isFunction(newValue))
        return newValue;
    // shallow compare keys of new value with current state
    const updatedKeys = Object.keys(newValue).reduce((prev, key) => Object.is(state[key], newValue[key]) ? prev : {
        ...prev,
        [key]: newValue[key],
    }, {});
    // any keys updated ?
    return Object.keys(updatedKeys).length === 0 ? state : { ...state, ...updatedKeys };
}
export function usePureState(initialState) {
    return useReducer(mergeStateReducer, undefined, isFunction(initialState) ? initialState : () => initialState);
}
//# sourceMappingURL=usePureState.js.map